import './Footer.scss';

import parse from 'html-react-parser';
import { observer } from 'mobx-react';

import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';

const Footer = observer(() => {
  const { cmsStore, authStore } = useStores();

  const preventMultisession = useFlag('prevent_multisession_enable', false);

  const { footer } = cmsStore;

  if (!authStore.isAuthenticationFlowDone || (preventMultisession && authStore.isDisconnectedByMultisession)) {
    return null;
  }

  return <footer className="site-footer">{footer && parse(footer)}</footer>;
});

export { Footer };
